import { render, staticRenderFns } from "./handidcard.vue?vue&type=template&id=0fb9e738&scoped=true&"
import script from "./handidcard.vue?vue&type=script&lang=js&"
export * from "./handidcard.vue?vue&type=script&lang=js&"
import style0 from "./handidcard.vue?vue&type=style&index=0&id=0fb9e738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb9e738",
  null
  
)

export default component.exports